import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

const DateRangePickerDesktop = ({ props, viewModel }) => {
  const { presets } = viewModel;

  return <RangePicker {...props} presets={presets} />;
};

export default DateRangePickerDesktop;
